import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "@ff/ui/tokens.css";
import "./styles/global.css";

const host = document.getElementById("root");
if (!host) throw new Error("Missing #root host element");

createRoot(host).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/**
 * Registering the worker is what makes the local-first claim true on a cold
 * start with no network. It is deliberately after render and deliberately
 * unawaited: a registration failure — a browser without service workers, a
 * private window, an insecure origin — must never stop the app from running,
 * because nothing the app does actually needs it.
 */
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => {
      // Nowhere to report it and nothing to do: the app works either way.
    });
  });
}
